import { useEffect, useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import styles from './ConfirmDialog.module.css';

let resolveRef: ((value: boolean) => void) | null = null;
let openRef: ((message: string, title?: string) => void) | null = null;

export function confirmDialog(message: string, title?: string): Promise<boolean> {
    return new Promise((resolve) => {
        resolveRef = resolve;
        openRef?.(message, title);
    });
}

export function ConfirmDialog() {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [title, setTitle] = useState('Confirmar');

    useEffect(() => {
        openRef = (msg, ttl) => {
            setMessage(msg);
            setTitle(ttl ?? 'Confirmar');
            setOpen(true);
        };
    }, []);

    const handle = (result: boolean) => {
        setOpen(false);
        resolveRef?.(result);
        resolveRef = null;
    };

    if (!open) return null;

    return (
        <div className={styles.overlay} onClick={() => handle(false)}>
            <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
                <div className={styles.iconWrap}>
                    <FiAlertTriangle size={28} />
                </div>
                <h3 className={styles.title}>{title}</h3>
                <p className={styles.message}>{message}</p>
                <div className={styles.footer}>
                    <button className={styles.cancelBtn} onClick={() => handle(false)}>
                        Cancelar
                    </button>
                    <button className={styles.confirmBtn} onClick={() => handle(true)}>
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
}
